module.exports = __webpack_public_path__ + "img/yiqiantui.108683be.png";